import ChicletNavExtended from 'components/Homepage/ChicletNavExtended/ChicletNavExtended';
import { withNavigationMenu } from 'hocs/page/withNavigationMenu';

export default withNavigationMenu(ChicletNavExtended);
